module.exports = __webpack_public_path__ + "static/media/Jimena.38f3d7bb.jpg";